import { BasicTabScreen } from '../../../lib/ui/BasicTabScreen';
import { TabScreenOptions } from '../../../odie/plugins/nav/TabNav';
import { EditorScreen } from '../../EditorScreen';
import { EditorSubMenu } from './EditorSubMenu';

export type EditorMiscMenuOptions = {
  screen: EditorScreen;
};

export class EditorMiscMenu extends BasicTabScreen {
  private screen!: EditorScreen;

  constructor(options: TabScreenOptions) {
    super(options);
  }

  public async prepare(options: EditorMiscMenuOptions) {
    this.screen = options.screen;

    const subMenuWidth = this.width * 0.45;

    const levelsMenu = new EditorSubMenu({
      width: subMenuWidth,
      height: this.height,
      title: 'LEVELS',
      buttons: {
        'COPY LEVEL': () => this.screen.copy(),
        'PASTE LEVEL': () => this.screen.paste(),
        'VALIDATE LEVELS': () => this.screen.validateOverridenLevels(),
        'PLAY ORIGINAL LEVEL': () => this.screen.playOriginalLevel(),
        'RESET PROD LEVELS': () => this.screen.resetProdLevels(),
        'RESET EDITOR': () => this.screen.resetEditor(),
      },
    });
    levelsMenu.x = this.width * 0.25 - levelsMenu.width * 0.5;
    levelsMenu.y = 0;
    this.view.addChild(levelsMenu);

    const fileMenu = new EditorSubMenu({
      width: subMenuWidth,
      height: this.height,
      title: 'FILE',
      buttons: {
        'UPLOAD MAPS': () => this.screen.uploadPuzzleMaps(),
        'DOWNLOAD MAPS': () => this.screen.downloadPuzzleMaps(),
        'UPLOAD SINGLE MAP': () => this.screen.uploadSinglePuzzleMap(),
        'DOWNLOAD SINGLE MAP': () => this.screen.downloadSinglePuzzleMap(),
        'PRE-GAME CHEATS': () => this.screen.openCheatsMenu(),
      },
    });
    fileMenu.x = this.width * 0.75 - fileMenu.width * 0.5;
    fileMenu.y = 0;
    this.view.addChild(fileMenu);
  }
}
